import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import i18next from 'i18next';

import { LargeSpacer } from '~/modules/coreUI/components/legacies/Spacers';
import OptionsList from './OptionsList';

const SearchInput = styled.input`
  /* Box Model */
  padding: 14px;
  width: 100%;
  height: 42px;
  border: ${props => props.theme.borders.size.thin}px solid
    ${props => props.theme.borders.color.light};
  border-radius: 5px;
  ::-webkit-input-placeholder {
    /* Color */
    color: ${props => props.theme.colors.labels.subtle};
  }
  /* Text */
  font-size: 14px;
  /* Color */
  color: ${props => props.theme.colors.labels.subtle};
`;

class FilterOptionsList extends Component {
  state = {
    searchText: '',
  };

  getMatchingOptions = listOfOptions => listOfOptions.filter(item => item.name.toLowerCase().search(this.state.searchText) !== -1);

  filterList = (event) => {
    this.setState({ searchText: event.target.value.toLowerCase() });
  };

  render() {
    return (
      <React.Fragment>
        <SearchInput type="text" placeholder={i18next.t('ecommerceCoreUI:search.title')} onKeyUp={this.filterList} />
        <LargeSpacer />
        <OptionsList
          filterCategoryName={this.props.filterCategoryName}
          listOfOptions={this.getMatchingOptions(this.props.listOfOptions)}
          onOptionClicked={this.props.onOptionClicked}
        />
      </React.Fragment>
    );
  }
}

FilterOptionsList.propTypes = {
  listOfOptions: PropTypes.arrayOf(PropTypes.any).isRequired,
  onOptionClicked: PropTypes.func.isRequired,
  filterCategoryName: PropTypes.string.isRequired,
};

export default FilterOptionsList;
